import './ReportSidebar.less';
import React, { useState } from 'react';
import { Menu, Icon } from 'antd';
import { AuditReportScoreData, SeoAuditCategoryStatusCounts, SeoAuditSections, SeoAuditStructure } from './types';

type Props = {
    sections: SeoAuditSections;
    generalScoreData: AuditReportScoreData;
    categorizedSections: Partial<SeoAuditStructure>;
    categorizedSectionsCounts: SeoAuditCategoryStatusCounts;
};

export default function AuditReportSidebar({ sections, generalScoreData, categorizedSections, categorizedSectionsCounts }: Props) {
    const [openKeys, setOpenKeys] = useState<string[]>(['general']);

    const handleOpenChange = (newOpenKeys: string[]) => {
        setOpenKeys(newOpenKeys.filter((openKey) => !openKeys.includes(openKey)));
    };

    return (
        <Menu
            mode="inline"
            openKeys={openKeys}
            onOpenChange={handleOpenChange}
            className="report-sidebar deep-analysis custom-scrollbar"
        >
            <Menu.Item
                key="1"
                data-cy="general"
                className="single-item"
            >
                <a
                    href="#header-seo-summary"
                    className="submenu-container"
                >
                    <span className="submenu-title">
                        <Icon type="check-circle" />
                        <span>General</span>
                    </span>
                    <div className="submenu-result-data">
                        <div className="submenu-result failed">
                            {generalScoreData.failed} <span className="result-data-indicator" />
                        </div>

                        <div className="submenu-result warning">
                            {generalScoreData.warning} <span className="result-data-indicator" />
                        </div>

                        <div className="submenu-result passed">
                            {generalScoreData.passed} <span className="result-data-indicator" />
                        </div>
                    </div>
                </a>
            </Menu.Item>

            {Object.entries(categorizedSections).map(([categoryName, sectionsDetails]) => (
                <Menu.ItemGroup key={categoryName}>
                    <Menu.Divider />
                    <Menu.SubMenu
                        data-cy={categoryName}
                        key={categoryName}
                        className="submenu-item"
                        title={
                            <div className="submenu-container">
                                <span className="submenu-title">
                                    <Icon type="check-circle" />
                                    <span>{categoryName}</span>
                                </span>
                                <div className="submenu-result-data">
                                    <div className="submenu-result failed">
                                        {categorizedSectionsCounts[categoryName].failed} <span className="result-data-indicator" />
                                    </div>

                                    <div className="submenu-result warning">
                                        {categorizedSectionsCounts[categoryName].warning} <span className="result-data-indicator" />
                                    </div>

                                    <div className="submenu-result passed">
                                        {categorizedSectionsCounts[categoryName].passed} <span className="result-data-indicator" />
                                    </div>
                                </div>
                            </div>
                        }
                    >
                        {sectionsDetails.map((sectionDetails) => (
                            <Menu.Item
                                key={sectionDetails.key}
                                data-cy={categoryName}
                                className={sections[sectionDetails.key].status}
                            >
                                <a href={`#${sectionDetails.key}`}>
                                    <span className="result-data-indicator" />
                                    {sectionDetails.title}
                                </a>
                            </Menu.Item>
                        ))}
                    </Menu.SubMenu>
                </Menu.ItemGroup>
            ))}
        </Menu>
    );
}
